import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Button,
  TextField
} from '@mui/material';
import { useState } from 'react';

export function ModalEditarMovimiento({
  open,
  onClose,
  movimiento,
  state,
  productos,
  díaBloqueado = false
}) {
  const [filaActual, setFilaActual] = useState(
    movimiento
      ? {
          prodId: movimiento.productoId,
          cant: movimiento.cantidad.toString(),
          precio: movimiento.precio.toString(),
          total: (movimiento.cantidad * movimiento.precio).toFixed(2)
        }
      : { prodId: '', cant: '', precio: '', total: '' }
  );

  const handleCantidadChange = (e) => {
    const cant = e.target.value;
    setFilaActual(prev => ({
      ...prev,
      cant,
      total: cant && prev.precio ? (parseFloat(cant) * parseFloat(prev.precio)).toFixed(2) : ''
    }));
  };

  const handlePrecioUnitarioChange = (e) => {
    const precio = e.target.value;
    setFilaActual(prev => ({
      ...prev,
      precio,
      total: prev.cant && precio ? (parseFloat(prev.cant) * parseFloat(precio)).toFixed(2) : ''
    }));
  };

  const handleTotalChange = (e) => {
    const total = e.target.value;
    setFilaActual(prev => ({
      ...prev,
      total,
      precio: prev.cant && total ? (parseFloat(total) / parseFloat(prev.cant)).toFixed(2) : ''
    }));
  };

  const handleGuardarEdicion = async () => {
    if (díaBloqueado) {
      alert('⛔ No puedes editar movimientos cuando hay un arqueo completado en el día');
      return;
    }

    if (!filaActual.cant || !filaActual.precio) {
      alert('Datos inválidos');
      return;
    }

    const success = await state.editarMovimiento(movimiento.id, filaActual.cant, filaActual.precio);

    if (success) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Editar Movimiento</DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Stack spacing={2}>
          <TextField
            label="Producto"
            fullWidth
            disabled
            value={productos.find(p => p.id === filaActual.prodId)?.nombre || ''}
          />

          <TextField
            label="Cantidad"
            type="number"
            fullWidth
            value={filaActual.cant}
            onChange={handleCantidadChange}
            inputProps={{ step: '0.01' }}
          />

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              label="Precio Unitario"
              type="number"
              fullWidth
              value={filaActual.precio}
              onChange={handlePrecioUnitarioChange}
              inputProps={{ step: '0.01' }}
            />

            <TextField
              label="Total"
              type="number"
              fullWidth
              value={filaActual.total}
              onChange={handleTotalChange}
              inputProps={{ step: '0.01' }}
              disabled
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" disabled={díaBloqueado} onClick={handleGuardarEdicion}>
          Guardar Cambios
        </Button>
      </DialogActions>
    </Dialog>
  );
}
